/* COPYRIGHT Esri - https://js.arcgis.com/5.1.20/LICENSE.txt */
import{once as e}from"../../core/events.js";function r(r,t){return new Promise((n,o)=>{r.readyState>=HTMLMediaElement.HAVE_CURRENT_DATA?n():(t(e(r,"canplay",n)),t(e(r,"error",o)))})}export{r as whenVideoPlayable};
